import DefaultValidation from '@/services/validations/DefaultValidation';
import * as Util from '@/functions/Util';

export default class AreaInteresseValidation extends DefaultValidation {
    constructor(msgs) {
		super(msgs);
	  }
	  validate(model, refs) {
		let validated = true;

		Object.entries(model).forEach(([key, value]) => {
			if(value!=null && typeof value == "string") model[key] = value.trim();
		});
	  
		if (Util.isNull(model.descricao)) {
			refs.nomeInput.focusedOut = true;
			validated = false;
		}

		return validated;
	}
}
